module.exports = __webpack_public_path__ + "static/media/notificationActive.19661535.png";